import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=6a5913cf&scoped=true"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=6a5913cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5913cf",
  null
  
)

export default component.exports